import { createContext, useContext, useState, useCallback } from "react";
import { TRANSLATIONS } from "../lib/i18n";
import { api } from "../lib/api";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem("cp_lang");
    if (saved === "fr" || saved === "en") return saved;
    // First visit: auto-detect French-Canadian (or any French) browser preference
    const langs = navigator.languages || [navigator.language || ""];
    return langs.some((l) => (l || "").toLowerCase().startsWith("fr")) ? "fr" : "en";
  });

  const setLang = useCallback((l) => {
    const next = l === "fr" ? "fr" : "en";
    localStorage.setItem("cp_lang", next);
    setLangState(next);
    // Persist to the logged-in user's profile so transactional emails match (best-effort).
    api.put("/auth/me/language", { lang: next }).catch(() => {});
  }, []);

  const t = useCallback((key) => {
    const table = TRANSLATIONS[lang] || TRANSLATIONS.en;
    return table[key] ?? TRANSLATIONS.en[key] ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "en", setLang: () => {}, t: (k) => k };
  return ctx;
}
